const baseState = {
    activeTab: "",
    selectedItem: null,
    showTokens: false,
    isClientTokens: false,
    showUserHistory: false,
    showClientHistory: false
}

const breadcrumbsReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_ACTIVE_TAB": {
			return {
				...state,
				activeTab: payload
			}
		}

		case "SET_SELECTED_ITEM": {
			return {
				...state,
				selectedItem: payload
			}
		}

		case "SET_SHOW_TOKENS": {
			return {
				...state,
				showTokens: payload
			}
		}

		case "SET_SHOW_CLIENTS_TOKENS": {
			return {
				...state,
				isClientTokens: payload
			}
		}

		case "SET_SHOW_USER_HISTORY": {
			return {
				...state,
				showUserHistory: payload
			}
		}

		case "SET_SHOW_CLIENT_HISTORY": {
			return {
				...state,
				showClientHistory: payload
			}
		}

        default:
            return state;
    }
}

export default breadcrumbsReducer